// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__1syzy","img_container":"About_img_container__39m2-"};